import React, { memo, useEffect } from "react";
import { BaseLayout, PrivateNavigationBar } from "~/components/layouts";
import { useAppDispatch, useAppSelector, useWindowFocus } from "~/hooks";
import { AppContainer, Col } from "~/components/elements";
import { Redirect } from "react-router-dom";
import isEmpty from "lodash/isEmpty";
import { stringify } from "querystring";
import { PAGE_URLS } from "~/constants";
import { sharedStyle } from "~/theme/shared-style";
import moment from "~/services/moment";
import { useSelector } from "react-redux";
import { RootState } from "~/redux/root-reducer";
import { fetchPackages, fetchSurveys } from "~/redux/dashboards/thunk";
import { logout } from "~/redux/auth/thunk";

interface Props {
  children: React.ReactNode;
}

export const PrivateLayout = memo(({ children }: Props) => {
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector(state => state.auth.currentUser);
  const expiredAt = useAppSelector(state => state.auth?.token?.expired_at);
  const isWindowFocused = useWindowFocus();
  const surveyData = useSelector((state: RootState) => state.dashboard.surveyData);
  const packageData = useSelector((state: RootState) => state.dashboard.packageData);
  const lastRequestStatusCode = useAppSelector(state => state.ui.lastRequestStatusCode);

  useEffect(() => {
    if (!surveyData?.length || !packageData?.length) {
      const fetchAppConfigData = () => {
        dispatch(fetchSurveys({}));
        dispatch(fetchPackages({}));
      };
      fetchAppConfigData();
    }
  }, [dispatch, surveyData, packageData]);

  useEffect(() => {
    if (lastRequestStatusCode === 401) {
      dispatch(logout());
    }
  }, [dispatch, lastRequestStatusCode]);

  if ((isEmpty(currentUser) && window.location.pathname !== PAGE_URLS.LOGIN) || !expiredAt) {
    const redirectTo = stringify({
      redirect: window.location.href,
    });
    return <Redirect to={`${PAGE_URLS.LOGOUT}?${redirectTo}`} />;
  }

  if (isWindowFocused && moment.unix(expiredAt!).isBefore()) {
    const redirectTo = stringify({
      redirect: window.location.href,
    });
    return <Redirect to={`${PAGE_URLS.LOGOUT}?${redirectTo}`} />;
  }

  // if (isMobile) {
  //   return (
  //     <BaseLayout>
  //       <UiIconButton
  //         onClick={() => setBoolBag({showMobileMenu: true})}
  //         aria-label="Show menu"
  //         icon={<UiIcon as={GiHamburgerMenu} boxSize={'8px'} />}
  //       />
  //       <UiDrawer isOpen={showMobileMenu} placement="left" onClose={() => setBoolBag({showMobileMenu: false})}>
  //         <UiDrawerOverlay />
  //         <UiDrawerContent>
  //           <UiDrawerCloseButton />
  //           <UiDrawerHeader>Create your account</UiDrawerHeader>
  //
  //           <UiDrawerBody>
  //             <UiInput placeholder="Type here..." />
  //             <Navigation />
  //             {children}
  //           </UiDrawerBody>
  //
  //           <UiDrawerFooter>
  //             <UiButton variant="outline" mr={3} onClick={() => setBoolBag({showMobileMenu: false})}>
  //               Cancel
  //             </UiButton>
  //             <UiButton>Save</UiButton>
  //           </UiDrawerFooter>
  //         </UiDrawerContent>
  //       </UiDrawer>
  //     </BaseLayout>
  //   );
  // }
  return (
    <BaseLayout>
      <Col minH="100dvh">
        <PrivateNavigationBar />
        <AppContainer as={Col} h="100%" maxW={sharedStyle.pageMaxWidth} flex={1}>
          {children}
        </AppContainer>
      </Col>
    </BaseLayout>
  );
});
